module.exports = __webpack_public_path__ + "img/color_autumn_clothes_square.cd8e2215.png";